/**
 * About Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the collection template.
 *
 * @namespace collection
 */

import loaded from '@/scripts/utils/loaded';
import {scrollScene, toggleClass} from '@/scripts/utils/scroll-scenes';

class Collection {

  collectionAnimations = () => {

    scrollScene({
      trigger: '.discovery__container',
      hook: 1,
      offset: 200,
      reverse: false,
      onToggle: toggleClass('.discovery__container', 'fade-in'),
    });
  };

  constructor() {
    this.collectionAnimations();
  }

}

loaded(() => new Collection());
